import { Checkbox, Tooltip } from 'antd';
import { templateEditor as strings } from '../strings';
import {
  ModalListRow,
  SmallButton,
  TemplateSheetActions,
  TemplateSheetCheckboxContainer,
  TemplateSheetFieldCount,
  TemplateSheetInfo,
} from '../styled';
import { DragHandle } from './DragHandle';
import { SheetNameInput } from './SheetNameInput';

export function TemplateSheetRow(props) {
  const sheet = props.sheet;
  const hasAnyColumnsSelected = !sheet.enabled || sheet.selectedColumns > 0;

  return (
    <ModalListRow
      draggable={sheet.enabled}
      onDragStart={event => props.onDragStart(event, sheet.sheetMetadataId)}
      onDragOver={event => props.onDragOver(event, sheet.sheetMetadataId)}
      onDragEnd={props.onDragEnd}
      style={{ opacity: props.draggedId === sheet.sheetMetadataId ? 0.5 : 1 }}
    >
      <TemplateSheetCheckboxContainer>
        <Tooltip
          placement='left'
          title={
            sheet.mandatory ? 'Required section - cannot be removed' : undefined
          }
        >
          <Checkbox
            data-testid={`et-modal-sheet-checkbox-${sheet.sheetMetadataId}`}
            checked={
              sheet.mandatory || (sheet.enabled && hasAnyColumnsSelected)
            }
            disabled={sheet.mandatory}
            onChange={event =>
              props.onToggleSheet(sheet.sheetMetadataId, event.target.checked)
            }
          />
        </Tooltip>
      </TemplateSheetCheckboxContainer>

      <TemplateSheetInfo>
        <SheetNameInput
          sheetMetadataId={sheet.sheetMetadataId}
          enabled={sheet.enabled}
        />
        <TemplateSheetFieldCount>
          {strings.fieldsSelected(sheet.selectedColumns, sheet.totalColumns)}
        </TemplateSheetFieldCount>
      </TemplateSheetInfo>

      <TemplateSheetActions>
        <Tooltip
          placement='right'
          title={
            !sheet.enabled
              ? 'This section must be selected before you can edit its columns.'
              : undefined
          }
        >
          <span>
            <SmallButton
              data-testid={`et-modal-edit-columns-button-${sheet.sheetMetadataId}`}
              size='small'
              onClick={() => props.onEditColumns(sheet.sheetMetadataId)}
              disabled={!sheet.enabled}
            >
              {strings.editColumns}
            </SmallButton>
          </span>
        </Tooltip>

        <DragHandle />
      </TemplateSheetActions>
    </ModalListRow>
  );
}
